export default __webpack_public_path__ + "images/4e046ce39d5ae61ced9583b693b884b6-spirituality.webp";